<template>
    <el-card shadow="hover">
        <label slot="header">lottie动画</label>
        需要在项目静态目录中创建lottie文件夹，将ui提供的lottie文件夹更名后复制到其中

        只要确保文件夹下有images文件夹和data.json文件即可
        <el-divider content-position="left">name="login-center" 名称需要lottie下文件夹命名相同</el-divider>
        <div style="width: 500px; height: 500px;background-color: #000">
            <j-lottie name="login-center"/>
        </div>
    </el-card>
</template>

<script>
    import JLottie from "./JLottie";
    export default {
        components: {
            JLottie
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
